/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, duration: NonNullable<unknown>, sets: NonNullable<unknown> }} Search_History_MetaInputs */

const en_us2_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 set`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} sets`)
	
};

const pt_br2_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 série`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} séries`)
	
};

const es_419_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 serie`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} series`)
	
};

const pt_pt2_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 série`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} séries`)
	
};

const fr_fr2_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 série`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} séries`)
	
};

const de_de2_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 Satz`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} Sätze`)
	
};

const it_it2_search_history_meta = /** @type {(inputs: Search_History_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.sets === 1 || i?.sets === "1")) return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · 1 serie`);
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.duration} · ${i?.sets} serie`)
	
};

/**
* | sets | output |
* | --- | --- |
* | "1" | "{date} · {duration} · 1 set" |
* | * | "{date} · {duration} · {sets} sets" |
*
* @param {Search_History_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_history_meta = /** @type {((inputs: Search_History_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_History_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_history_meta(inputs)
	if (locale === "es-419") return es_419_search_history_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_search_history_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_search_history_meta(inputs)
	if (locale === "de-DE") return de_de2_search_history_meta(inputs)
	if (locale === "it-IT") return it_it2_search_history_meta(inputs)
	return en_us2_search_history_meta(inputs)
});
export { search_history_meta as "search.history_meta" }